// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  GESTION_OPERATIVA_GET_COSTOS_PATENTAMIENTO,
} from './constants';
import { BFFAgent } from '../../../common/BFFAgent';


export function getCostosPatentamiento(patentamientoData, bool) {
  return async (dispatch, getState) => {

    const { gestionOperativa } = getState()
    //Se corrobora que el Modal de Reserva no esta activo, si esta no se debe ejecutar la accion.
    let costoPatentamiento = 0
    const { clientProvince, clientCountry, ...data } = patentamientoData;
    let province = {};
    if(clientProvince && clientCountry ) {
      province = await BFFAgent.Locations.getProvinceById(clientCountry, clientProvince);
    }

    const formattedData = { ...data, clientProvince: province.nombre || ''}
    costoPatentamiento = await BFFAgent.Presupuestador.getCostosDePatentamiento(formattedData);

    const dataValue = {
      ...gestionOperativa.sale,
    }
   
    dataValue.delivery_costs = costoPatentamiento
    dataValue.patentamientoCheck = bool
    dataValue.client_license_plate = bool
    if (!bool) {
      dataValue.delivery_costs_original = costoPatentamiento
    }

    dispatch( {
      type: GESTION_OPERATIVA_GET_COSTOS_PATENTAMIENTO,
      data: dataValue,
    })
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_GET_COSTOS_PATENTAMIENTO) {
      return {
        ...state,
        sale: action.data,
        delivery_costs_manually_edited: false,
      };
  }
  else {
    return state;
  }      
}
